import * as types from '../actions/actionTypes';
import {REST_URL} from '../constants';
import Adal from '../adal/adal-request';

export const currentCipIdeaPage = (state = {Data : [], TotalPageCount : 0, PageIndex : 1, Loading : true}, action) => {
  switch(action.type){
    case types.FETCH_CIP_IDEAS : 
    case types.FETCH_CIP_IDEAS_REJECTED:
      return {Data : [], TotalPageCount : 0, PageIndex : 1, Loading : true};
    case types.FETCH_CIP_IDEAS_FULFILLED:
      return {...action.payload, Loading : false};
    default :
      return state;
  }
}

export const currentCipIdea = (state = {Loading : true}, action) => {
  switch(action.type){
    case types.FETCH_CIP_IDEA : 
    case types.FETCH_CIP_IDEA_REJECTED:
      return {Loading : true};
    case types.FETCH_CIP_IDEA_FULFILLED:
      return {...action.payload, Loading : false};
    case types.POST_CIP_IDEA : 
    case types.POST_CIP_IDEA_REJECTED:
    case types.POST_CIP_IDEA_FULFILLED:
      return state;
    case types.POST_CIP_PROGRESS : 
    case types.POST_CIP_PROGRESS_REJECTED:
      return state;
    case types.POST_CIP_PROGRESS_FULFILLED:
      return {...action.payload, Loading : false};
    default :
      return state;
  }
}

export const currentCipFiles = (state = {Files : [],Loading : true}, action) => {
  switch(action.type){
    case types.FETCH_CIP_FILES : 
    case types.FETCH_CIP_FILES_REJECTED:
      return {...state,Files : [], Loading : true};
    case types.FETCH_CIP_FILES_FULFILLED:
      var Files = action.payload.map((file, idx) =>{
         return Object.assign(file, {url : REST_URL + "fileItems/download/" + file.Id + "?access_token=" + Adal.getCachedToken()});
      });
      return { ...state, Files : Files , Loading : false};
    default :
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/cipIdeasReducer.js